class AjaxInfiniteResults {

    constructor(container, searchParameters) {

        this.container = container
        this.searchParameters = searchParameters

        // Offset for the next request of results
        this.pageIncrement = 10

        this.currentPage = 0

        this.queryParameters = {
            page: 0,
            filters: [],
            searchTerm: '*',
        }

        this.waypoint = null

        this.spinner = null

        this.endpoint = ''

        this.init();
    }


    /**
     * @method init
     * @returns {undefined}
     */
    init() {
        this.spinner = $('[rel="search-results--spinner"]')

        this.setupQueryParameters()

        this.initInfiniteScroll()
    }

    /**
     * Check if the last block is near the end of the last block and load new results, if required
     */
    initInfiniteScroll() {
        this.waypoint = new Waypoint({
            element: document.getElementById('waypoint'),
            offset: '100%',
            handler: (direction) => {
                if (direction === 'down') {
                    Waypoint.disableAll()
                    this.getNextPageResults()
                }
            },
        })
    }

    getNextPageResults() {
        this.incrementCurrentPage()
        this.getResults(this.currentPage)
    }

    /**
     * Request new results
     * @param page
     */
    getResults(page) {
        this.queryParameters.page = page

        if (this.endpoint !== '') {
            $.post(this.endpoint, this.queryParameters, (results) => {
                this.processResults(results, page)
            })
        }
    }

    /**
     * Append new results and control behavior of the list
     * @param results
     * @param page
     */
    processResults(results, page) {
        if (results !== '') {
            this.appendResults(results)

            this.triggerNewResultsEvent()

            // Check if the waypoint is already visible
            // if so, more results should be loaded to fill the screen
            if (this.isScrolledIntoView('#waypoint')) {
                this.getNextPageResults()
            } else {
                Waypoint.enableAll()
            }
        } else {
            this.hideSpinner()
        }
    }

    /**
     * Append a new result block of the new results to the result block
     *
     * @param results
     */
    appendResults(results) {
        $(this.container).append(results)
    }

    hideSpinner() {
        $(this.spinner).addClass('inactive')
    }

    /**
     * Increment the result offset
     */
    incrementCurrentPage() {
        this.currentPage++
    }

    /**
     * Increment the result offset
     */
    triggerNewResultsEvent() {
        $(document).trigger('newResultsAppended')
    }

    /**
     * Load the JSON parameters and apply them to the requests for more results
     */
    setupQueryParameters() {
        if (this.searchParameters.filters !== undefined && Object.keys(this.searchParameters.filters).length) {
            this.queryParameters.filters = this.searchParameters.filters
        }
        if (this.searchParameters.searchTerm !== undefined && typeof this.searchParameters.searchTerm === 'string') {
            this.queryParameters.searchTerm = this.searchParameters.searchTerm
        }
        if (this.searchParameters.endpoint !== undefined && typeof this.searchParameters.endpoint === 'string') {
            this.endpoint = this.searchParameters.endpoint
        }
    }

    /**
     * Checks if the given element is visible
     *
     * @param element
     * @returns {boolean}
     */
    isScrolledIntoView(element) {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elemTop = $(element).offset().top;
        const elemBottom = elemTop + $(element).height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop
    }

}

function initAjaxInfiniteResults() {
    const container = $('[rel="search-results--ajax-container"]');
    const searchParameters = window.searchParameters;
    if (container.length && searchParameters) {
        new AjaxInfiniteResults(container, searchParameters)
    }
}

// If the script is initialized after the document is already loaded, initialize modules instantly
if (document.readyState !== 'loading') {
    initAjaxInfiniteResults()
} else {
    // else add an event listener for when the document is fully loaded
    document.addEventListener('DOMContentLoaded', initAjaxInfiniteResults)
}

